export const reportSpecialUnitsTypes = {
  SET_SPECIAL_UNITS_FILTERS: 'SET_SPECIAL_UNITS_FILTERS',
  RESTORE_INITIAL: 'REPORT_SPECIAL_UNITS_RESTORE_INITIAL'
};
